// src/config/config.js
// const BASE_URL = "http://localhost:8080/api"
const BASE_URL = "https://ofellio.com/api";
const BASE_URL_Socket = "https://ofellio.com";
//const BASE_URL_Socket = "http://localhost:8080"
const Frontend = "https://ofellio.com";
//const Frontend= "http://localhost:3000"
export { BASE_URL, BASE_URL_Socket, Frontend };
